export default __webpack_public_path__ + "static/media/background.ddb089c6.png";